import t from "./highrise1419.mjs";
import i from "./highrise1420.mjs";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};
